<template>
  <div class="">
    <div style="float:left">
      <vs-chip
        style="cursor:pointer;"
        v-if="filtrosAplicados.length > 0"
        v-on:click.native="setFilters()"
        data-cy="setFilters"
      >
        <vs-avatar icon="search" color="primary" :badge="filtrosAplicados.length"/>
        <strong>Buscar</strong>
      </vs-chip>
      <vs-chip
        style="cursor:pointer;"
        color="gray"
        v-if="!filtrosAplicados.length"
        v-on:click.native="setFilters()"
      >
        <vs-avatar icon="search" color="#ccc"/>
        <strong
          data-cy="search-without-filters"
        >Buscar sin filtros aplicados
        </strong>
      </vs-chip>
      <vs-chip
        :color="colores.navbar"
        v-if="hasQueryFilters"
        style="cursor: context-menu"
        v-on:click.native="clearQueryFilters()"
      >
        <vs-avatar icon="link" color="primary"/>
        <strong>Borrar filtros de enlace</strong>
      </vs-chip>
    </div>
    <div style="float:right">
      <vs-dropdown vs-trigger-click data-cy="add-filter">
        <vs-chip color="primary">
          <vs-avatar
            icon="add"
            color="primary"
          />
          Agregar filtro
        </vs-chip>
        <vs-dropdown-menu class="scroll-options" data-cy="list">
          <vs-input
            type="text"
            v-model="search"
            v-if="filtrosDisponibles.length >= showFilterOnNumberElements"
            data-cy="filter-input-search"
          />
          <vs-dropdown-item
            v-for="(filter, index) in avalaibleFiltersSearch"
            :key="`filter-${ index }`"
            v-on:click="addFilter(filter)"
            style="width:200px"
            :data-cy="'filter-'+filter.campo"
          >
            {{ filter.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <vs-chip
      color="primary" transparent
      v-for="(filtro, index) in filtrosAplicadosFiltered"
      :key="`filtro-aplicado-${ index }`"
      style="cursor: context-menu"
    >
      <vs-avatar
        data-cy="clear"
        icon="clear"
        v-on:click.native="removeFilter(filtro)"
        color="primary"
      />
      <span />
      <vs-tooltip
        :text="`Modificar filtro ${filtro.nombre}`"
        v-on:click.native="modificarFiltro(filtro)"
      >
        <strong>{{ filtro.nombre }}: </strong>
        <span class="pl-1">
          {{ filtro.valorFormateado }}
        </span>
      </vs-tooltip>
    </vs-chip>
    <b-modal
      :title="`Filtrar por ${actualFilter.nombre}`"
      ref="configFiltro"
      @cancel="closeModal(actualFilter)"
      @close="closeModal(actualFilter)"
      no-close-on-backdrop
      centered
      hide-footer
      :hide-header-close="editMood"
    >
      <div>
        <div v-if="actualFilter.tipo === 'creatingEntity'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.creatingEntity"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'recipientEntity'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.recipientEntity"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'selectorNotificado'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.notified"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'estadoTramitacion'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.status"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'estadoEtapa'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.stage"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'selectorDistribuido'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.distributed"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'documentType'">
          <div class="texto-normal">
            <v-select
              v-model="filterOptions.documentType"
              :options="actualFilter.opciones"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo== 'texto'">
          <div class="texto-normal">
            <b-form-input
              class="w-100"
              v-model="text"
              placeholder="Agregar"
              :type="actualFilter.tipoInput || 'text'"
            />
            <small v-if="actualFilter.mensaje">
              {{actualFilter.mensaje}}
            </small>
          </div>
        </div>
      </div>
      <div class="text-center mt-2">
        <vs-button size="small" v-on:click="verificarFiltrosAlCerrar" >
          Confirmar
        </vs-button>
      </div>
    </b-modal>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex';
import Vue from 'vue';

export default {
  name: 'FiltrosDocDigital',
  props: {
    filtersView: {
      type: Object,
      required: true
    },
    periodos: {
      type: Array,
      required: false
    },
    documentType: {
      type: Array,
      required: false
    },
    entities: {
      type: Array,
      required: false
    },
    myEntities: {
      type: Array,
      required: false
    },
    hasQueryFilters: {
      type: Boolean,
      default: false
    },
    clearQueryFilters: {
      type: Function
    },
    showFilterOnNumberElements: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      search: '',
      editMood: false,
      modalFilter: false,
      actualFilter: {},
      filtrosAplicados: [],
      filtrosDisponibles: [],
      selectAllOptions: false,
      tipoRangoFechaAvanzado: false,
      tipoRango: false,
      fechaSimpleActual: '',
      rangoAvanzado: {
        desde: '',
        hasta: ''
      },
      tag: '',
      tags: [],
      text: '',
      filterOptions: {
        creatingEntity: [],
        recipientEntity: [],
        documentType: [],
        notified: [],
        status: [],
        stage: [],
        distributed: [],
      }
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'actualFilter.valorFormateado': function (nuevoValor) {
      this.actualFilter.valorFormateado = nuevoValor;
    },
    // eslint-disable-next-line func-names
    'filterOptions.documentType': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    // eslint-disable-next-line func-names
    'filterOptions.creatingEntity': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    // eslint-disable-next-line func-names
    'filterOptions.recipientEntity': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    // eslint-disable-next-line func-names
    'filterOptions.notified': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    // eslint-disable-next-line func-names
    'filterOptions.status': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    // eslint-disable-next-line func-names
    'filterOptions.stage': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    // eslint-disable-next-line func-names
    'filterOptions.distributed': function (valorNuevo) {
      if (valorNuevo) {
        this.actualFilter.valor = valorNuevo.value;
        this.actualFilter.valorFormateado = valorNuevo.label;
      }

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      });
    },
    text(valorNuevo) {
      const valor = valorNuevo;
      this.actualFilter.valor = valor; // .join(",");
      this.actualFilter.valorFormateado = valor;

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor,
            valorFormateado: valor
          };
        }
        return filterApplied;
      });
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores
    }),
    filtrosAplicadosFiltered() {
      return this.filtrosAplicados.filter((filtro) => filtro.valor !== '');
    },
    avalaibleFiltersSearch() {
      if (this.search && this.search.length > 1) {
        return Object.values(this.filtrosDisponibles)
          .filter((filtro) => filtro.nombre.toLowerCase().includes(this.search.toLowerCase()));
      }
      return this.filtrosDisponibles;
    }
  },
  methods: {
    clearOptions() {
      this.tag = '';
      this.tags = [];
      this.text = '';
    },
    removeFilter(filter) {
      this.filtrosAplicados = this.filtrosAplicados
        .filter((filterApplied) => filterApplied.campo !== filter.campo);
      switch (filter.tipo) {
        case 'documentType': {
          this.filterOptions.documentType = [];
          break;
        }
        case 'selectorNotificado': {
          this.filterOptions.notified = [];
          break;
        }
        case 'estadoTramitacion': {
          this.filterOptions.status = [];
          break;
        }
        case 'estadoEtapa': {
          this.filterOptions.stage = [];
          break;
        }
        case 'selectorDistribuido': {
          this.filterOptions.distributed = [];
          break;
        }
        case 'creatingEntity': {
          this.filterOptions.creatingEntity = [];
          break;
        }
        case 'recipientEntity': {
          this.filterOptions.recipientEntity = [];
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
    },
    modificarFiltro(filter) {
      this.editMood = true;
      this.actualFilter = filter;
      if (this.actualFilter.tipo === 'rangoFecha') {
        if (this.actualFilter.valor.includes('--')) {
          this.tipoRangoFechaAvanzado = true;
          const [desde, hasta] = filter.valor.split('--');
          this.rangoAvanzado.desde = desde;
          this.rangoAvanzado.hasta = hasta;
        } else {
          this.tipoRangoFechaAvanzado = false;
        }
      } else if (this.actualFilter.tipo === 'numero' || this.actualFilter.tipo === 'texto') {
        // this.tags = this.actualFilter.valor.map((valor) => ({ value: valor }));
        this.text = this.actualFilter.valor;
        this.tipoRango = this.actualFilter.valor.includes('--');
      }

      this.actualFilter.valor = filter.valor;
      this.$refs.configFiltro.show();
    },
    seleccionarTodos() {
      this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
    },
    closeModal(filter) {
      this.removeFilter(filter);
      this.editMood = false;
    },
    verificarFiltrosAlCerrar() {
      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter) => filter.valor.length > 0 && filter.valor !== '');

      // this.actualFilter = {};
      this.$refs.configFiltro.hide();
      this.editMood = false;
    },
    setFilters(onMounted = false) {
      const query = [];
      // para los filtros
      this.filtersView.filtrosFijos.forEach((filter) => {
        const { valor } = filter;
        query.push(`${ filter.campo }:${ valor}`);
      });
      if (onMounted) {
        // para los filtros disponibles que fueron aplicados
        this.filtersView.filtrosHabilitados.filter((item) => item.inicial).forEach((filter) => {
          this.filtrosAplicados.push(filter);
        });
      }
      this.filtrosAplicados.forEach((filter) => {
        if (filter.tipo === 'rangoFecha' && !filter.valor.includes('--')) {
          const inicio = this.formatoTipoRango(filter.valor);
          const fin = Vue.moment().format('YYYY-MM-DD');
          query.push(`${filter.campo}:${inicio}--${fin}`);
        } else if (filter.valor.length > 0 && filter.valor !== '') {
          query.push(`${ filter.campo }:${ filter.valor }`);
        }
      });

      this.$emit('filtros-aplicados', query.join('|'), onMounted);
    },
    searchAvailableFilters() {
      let { filtrosHabilitados } = this.filtersView;

      filtrosHabilitados = filtrosHabilitados
        .sort(({ nombre: a }, { nombre: b }) => a.localeCompare(b));
      this.filtrosDisponibles = [...filtrosHabilitados];
    },
    setOptionsFilter(addedFilter) {
      let opciones = [];
      switch (addedFilter.tipo) {
        case 'recipientEntity': {
          opciones = this.entities;
          break;
        }
        case 'documentType': {
          opciones = this.documentType.map((document) => ({
            value: document.label,
            label: document.label
          }));
          break;
        }
        case 'estadoTramitacion':
        case 'estadoEtapa':
        case 'selectorNotificado': {
          opciones = addedFilter.opciones;
          break;
        }
        case 'selectorDistribuido': {
          opciones = addedFilter.opciones;
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      return opciones;
    },
    addFilter(filter) {
      this.actualFilter = {};
      this.clearOptions();

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valor: filter.valor,
            valorFormateado: filter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter2) => filter2.valor.length > 0 && filter2.valor !== '');

      const isApplied = this.filtrosAplicados
        .some((filterApplied) => filterApplied.campo === filter.campo);

      if (isApplied) {
        return;
      }

      this.actualFilter = filter;
      const addedFilter = filter;
      switch (addedFilter.tipo) {
        case 'documentType': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'creatingEntity': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'recipientEntity': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'estadoTramitacion':
        case 'estadoEtapa':
        case 'selectorNotificado': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'selectorDistribuido': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      this.filtrosAplicados.push(addedFilter);
      this.$refs.configFiltro.show();
    },
    selectFilter(filter) {
      this.actualFilter.valorFormateado = filter.valor
        .map((valor) => this.actualFilter.opciones[valor])
        .join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valorFormateado: this.actualFilter.valorFormateado,
            valor: filter.valor
          };
        }
        return filterApplied;
      });
      if (this.actualFilter.valor.length === Object.keys(this.actualFilter.opciones).length) {
        this.selectAllOptions = true;
      }
    }
  },
  mounted() {
    this.periodosDisponibles = this.periodos?.filter((periodo) => periodo.valor !== 'personalizado') || [];
    this.searchAvailableFilters();
    this.setFilters(true);
  }
};

</script>
<style>
.scroll-options {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
